export * from './Block';
try {
    // @ts-ignore
    Block.displayName = "Block";
    // @ts-ignore
    Block.__docgenInfo = { "description": "", "displayName": "Block", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Block/index.ts#Block"] = { docgenInfo: Block.__docgenInfo, name: "Block", path: "src/components/Block/index.ts#Block" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    BlockDocz.displayName = "BlockDocz";
    // @ts-ignore
    BlockDocz.__docgenInfo = { "description": "", "displayName": "BlockDocz", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Block/index.ts#BlockDocz"] = { docgenInfo: BlockDocz.__docgenInfo, name: "BlockDocz", path: "src/components/Block/index.ts#BlockDocz" };
}
catch (__react_docgen_typescript_loader_error) { }